var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentTag,{tag:"component",class:{
        ButtonBehaviour__root: true,
        'ButtonBehaviour__root--disabled': _vm.disabled,
    },attrs:{"disabled":_vm.disabled,"type":_vm.currentTag === 'button' ? _vm.type : null,"href":_vm.currentTag === 'a' ? _vm.currentHref : null,"for":this.for !== '' ? this.for : null},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }